/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'

import { BATTLE_TYPES, BONUS_TYPES, RESERVE_TYPES } from 'constants'
import styles from './SingleValueBonusDescription.scss'

const nbsp = <span>&nbsp;</span>

export const BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION = {
    [BATTLE_TYPES.ALL_BATTLES]: (duration) => (
        <FormattedMessage
            id='reserve_info_bar.battle_types.all_battles'
            defaultMessage='во всех режимах боев на {duration}{nbsp}ч'
            values={{
                duration: (
                    <span className={cx(styles.duration, duration.isHighlightEnabled && styles.duration__glow)}>
                        {duration.value}
                    </span>
                ),
                nbsp,
            }}
        />
    ),
    [BATTLE_TYPES.RANDOM_BATTLES]: (duration, bonusType) => {
        if (bonusType === BONUS_TYPES.EXTRA_CREDITS)
            return (
                <FormattedMessage
                    id='reserve_info_bar.battle_types.random_battles_and_steel_hunter'
                    defaultMessage='в Случайных боях, а также на Линии фронта и в Стальном охотнике на {duration}{nbsp}ч'
                    values={{
                        duration: (
                            <span className={cx(styles.duration, duration.isHighlightEnabled && styles.duration__glow)}>
                        {duration.value}
                    </span>
                        ),
                        nbsp,
                    }}
                />
            )
        return (
            <FormattedMessage
                id='reserve_info_bar.battle_types.random_battles'
                defaultMessage='в Случайных боях и на Линии фронта на {duration}{nbsp}ч'
                values={{
                    duration: (
                        <span className={cx(styles.duration, duration.isHighlightEnabled && styles.duration__glow)}>
                        {duration.value}
                    </span>
                    ),
                    nbsp,
                }}
            />
        )
    },
    [BATTLE_TYPES.CLAN_BATTLES]: (duration) => (
        <FormattedMessage
            id='reserve_info_bar.battle_types.clan_battles'
            defaultMessage='в клановых и турнирных боях на {duration}{nbsp}ч'
            values={{
                duration: (
                    <span className={cx(styles.duration, duration.isHighlightEnabled && styles.duration__glow)}>
                        {duration.value}
                    </span>
                ),
                nbsp,
            }}
        />
    ),
}

export const BATTLE_TYPE_RESERVE_DESCRIPTION = {
    [BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE]: (
        <FormattedMessage
            id='reserve_info_bar.battle_types.battles_for_stronghold_and_sorties'
            defaultMessage='в Вылазках и при Наступлениях на 1 бой'
        />
    ),
    [BATTLE_TYPES.SORTIE]: (
        <FormattedMessage
            id='reserve_info_bar.battle_types.sortie'
            defaultMessage='в Вылазках на 1 бой'
        />
    ),
    [BATTLE_TYPES.BATTLE_FOR_STRONGHOLD]: (
        <FormattedMessage
            id='reserve_info_bar.battle_types.battles_for_stronghold'
            defaultMessage='за результат проведённого Наступления'
        />
    ),
}

export const RESERVE_TYPE_CONDITION = {
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='reserve_info_bar.with_artillery_strike'
            defaultMessage='при вызове артобстрела'
        />
    ),
    [RESERVE_TYPES.AIRSTRIKE]: (
        <FormattedMessage
            id='reserve_info_bar.with_airstrike'
            defaultMessage='при вызове авиаудара'
        />
    ),
}



// WEBPACK FOOTER //
// ./components/ReserveBonus/components/SingleValueBonusDescription/translations.jsx